import { render, staticRenderFns } from "./Hornos.vue?vue&type=template&id=6fa41f96"
import script from "./Hornos.vue?vue&type=script&lang=js"
export * from "./Hornos.vue?vue&type=script&lang=js"
import style0 from "./Hornos.vue?vue&type=style&index=0&id=6fa41f96&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports